import React from 'react';
import { utcToGmt } from '../../components/utils';

import * as S from './styles';
import { CurrencyText } from '../../components/CurrencyText';
import { DateText } from '../../components';

export const Bill = ({ dataBilling }) => {
  const totalAmount = dataBilling.invoiceItems?.reduce((sum, item) => sum + (item.amount || 0), 0) || 0;

  const headCellStyle = {
    fontSize: '14px',
    borderTopLeftRadius: '8px',
    borderBottom: '1px solid #dfe1e6'
  }
    
  const cellStyle = {
    borderBottom: '1px solid #dfe1e6',
    fontSize: '14px',
    padding: '8px',
  };

  return (
    <S.ContainerTableBilling className='table-billing'>
      <S.SubTitle style={{ marginBottom: '15px' }}>Detalhes da Fatura</S.SubTitle>

      <S.Section>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <div>
            <S.Text>Data da Emissão: </S.Text>
            <S.SimpleText>
              <DateText date={utcToGmt(dataBilling.invoiceCreatedDate)} />
            </S.SimpleText>
          </div>

          <div>
            <S.Text>Identificador da Fatura:</S.Text>
            <S.SimpleText>{dataBilling.invoiceIdentify}</S.SimpleText>
          </div>
          
        </div>
      </S.Section>

      <S.Table>
        <S.TableHeader>
          <S.TableRow>
            <S.TableHead style={headCellStyle}>Item</S.TableHead>
            <S.TableHead style={{ ...headCellStyle, textAlign: 'right' }}>Valor</S.TableHead>
          </S.TableRow>
        </S.TableHeader>
        <S.TableBody>
          {dataBilling.invoiceItems.map((item, index) => (
            <S.TableRowBody key={index}>
              <S.TableCell style={cellStyle}>
                  {item.description}
              </S.TableCell>
              <S.TableCell style={{ ...cellStyle, textAlign: 'right' }}>
                <CurrencyText value={item.amount} />
              </S.TableCell>
            </S.TableRowBody>
          ))}
        </S.TableBody>
        <S.TableHeader>
          <S.TableRow>
            <S.TableHead style={{ ...headCellStyle }}>TOTAL</S.TableHead>
            <S.TableHead style={{ ...headCellStyle, textAlign: 'right' }}>
              <CurrencyText value={totalAmount} />
            </S.TableHead>
          </S.TableRow>
        </S.TableHeader>
      </S.Table>
    </S.ContainerTableBilling>
  );
};
